import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 11.727c-1.006 0-1.984.121-2.92.35a7.462 7.462 0 0 0-1.11-2.53A15.014 15.014 0 0 1 24 9c2.73 0 5.29.73 7.495 2.004a6.164 6.164 0 0 0-2.242 1.901A12.226 12.226 0 0 0 24 11.727ZM9 24c0-1.396.19-2.747.547-4.03.756.516 1.61.898 2.53 1.11-.229.936-.35 1.914-.35 2.92 0 5.846 4.088 10.737 9.56 11.972a4.767 4.767 0 0 0 1.357 2.968C14.995 38.254 9 31.827 9 24Zm21.818 11.59c0-.439-.06-.865-.172-1.271A12.263 12.263 0 0 0 36.273 24c0-.568-.039-1.127-.114-1.674a6.139 6.139 0 0 0 2.49-1.57C38.878 21.8 39 22.886 39 24c0 6-3.523 11.178-8.614 13.577.28-.61.432-1.284.432-1.986ZM16.97 17.317a4.773 4.773 0 1 1 .874-1.052l2.038 1.969a6.108 6.108 0 0 1 3.436-1.051c1.948 0 3.684.907 4.808 2.323l2.927-1.759a3.41 3.41 0 1 1 .743 1.144l-2.945 1.77a6.138 6.138 0 0 1-3.171 8.323l.643 4.581a2.046 2.046 0 0 1 .548 3.899l.02.14-1.35.19-.032-.228a2.046 2.046 0 0 1-.524-3.724l-.629-4.474a6.136 6.136 0 0 1-5.516-10.245l-1.87-1.806Zm17.257-.134a.682.682 0 1 0 0-1.364.682.682 0 0 0 0 1.364Zm-18.409-3.41a2.045 2.045 0 1 1-4.09 0 2.045 2.045 0 0 1 4.09 0Zm7.5 12.955a3.41 3.41 0 1 0 0-6.818 3.41 3.41 0 0 0 0 6.818Z",
    fill: "currentColor"
  }));
};

var SvgIntegrations = styled(SvgComponent).withConfig({
  displayName: "Integrations__SvgIntegrations",
  componentId: "sc-8ol83c-0"
})(["", " ", ""], size, color);
export default SvgIntegrations;